// extracted by mini-css-extract-plugin
export default {"snackbar":"Notification_snackbar__DEAV1"};